"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JysLevelRequest = void 0;
var JysLevelRequest = /** @class */ (function () {
    function JysLevelRequest() {
    }
    return JysLevelRequest;
}());
exports.JysLevelRequest = JysLevelRequest;
;
//# sourceMappingURL=jysLevel.request.js.map